import { render, staticRenderFns } from "./CostDetail.vue?vue&type=template&id=4d56a10a&scoped=true"
import script from "./CostDetail.vue?vue&type=script&setup=true&lang=ts"
export * from "./CostDetail.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./CostDetail.vue?vue&type=style&index=0&id=4d56a10a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d56a10a",
  null
  
)

export default component.exports